export const imageSourceToMixpanelName = {
  videoscribe: 'VideoScribe',
  'noun-project': 'Noun Project',
  'streamline-graphics': 'Streamline - Graphics'
};
